module.exports = __webpack_public_path__ + "media/ko_kr_s2_HoSook.788b94d8.mp3";